import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {errorRoute, notificationRoute, controlEnvRoute} from '@app/layouts';
import {DEBUG_INFO_ENABLED} from '@app/app.constants';
import {LoginComponent} from '@app/shared';
import {AuthGuardServiceLogin} from '@core/auth/auth-guard-service-login';

const LAYOUT_ROUTES = [notificationRoute, controlEnvRoute, ...errorRoute];

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        ...LAYOUT_ROUTES,
        {
          path: 'login',
          component: LoginComponent,
          data: {
            authorities: [],
            pageTitle: 'login.Đăng nhập_title',
          },
          canActivate: [AuthGuardServiceLogin],
        },
        {
          path: '',
          // TODO: redirect dashboard to danhsachlo until there is request from dashboard
          redirectTo: 'danh-sach-lo',
          pathMatch: 'full',
        },
        {
          path: 'policy',
          loadChildren: () =>
            import('./policy/policy.module').then((m) => m.PolicyModule),
          data: {
            authorities: [],
            pageTitle: 'policy.Chính sách bảo mật_title',
          },
        },
        {
          path: 'support',
          loadChildren: () =>
            import('./support/support.module').then((m) => m.SupportModule),
          data: {
            authorities: [],
            pageTitle: 'support.support-page.Hỗ trợ_title',
          },
        },
      ],
      {
        enableTracing: DEBUG_INFO_ENABLED,
        anchorScrolling: 'enabled',
      },
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
